<template>
    <div>
        <v-dialog v-model="value" max-width="60%" persistent>
            <v-card class="elevation-16 mx-auto">
                <v-card-title class="headline" primary-title>
                    {{ $t('ship_request.title')  }}
                </v-card-title>

                <v-divider></v-divider>
                <v-card-text>
                    <v-container align="center">
                        <v-row align="start" no-gutters>
                            <v-col cols="12" sm="6" class="pr-2">
                                <v-row no-gutters> 
                                    <v-col cols="12">
                                        <v-numeric-field v-model="editedItem.totalEdit" v-bind:label="$t('ship_request.money_charge')" outlined dense>
                                        </v-numeric-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-numeric-field v-model="editedItem.numberOfProductReceived" v-bind:label="$t('ship_request.number_product_receive')" outlined dense>
                                        </v-numeric-field>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-col cols="12" sm="6" class="pl-2">
                                <v-row no-gutters> 
                                    <v-col cols="12">
                                        <v-textarea v-model="editedItem.shipNote" v-bind:label="$t('ship_request.note_ship')"  outlined dense></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-col cols="12">
                                <span class="font-weight-black pb-2">  {{ $t('detail_request.ship_infor') }} <v-icon class="pb-2" @click="editCustomer"> edit </v-icon> </span>
                                <v-col> 
                                    <v-row> 
                                        <span class="pb-1"> {{ $t('detail_request.customer_infor') }} </span>
                                    </v-row>
                                    <v-row class="pb-1"> {{ $t('detail_request.fullname') }} {{ customer.fullname }}</v-row>
                                    <v-row class="pb-1"> {{ $t('detail_request.phone') }} {{ customer.phone }} </v-row>
                                    <v-row class="pb-1"> 
                                        {{ $t('detail_request.facebook') }} <a :href="customer.facebook" target="_blank"> {{ customer.facebook ? customer.facebook : '' }} </a>     
                                    </v-row>
                                </v-col>

                                <v-col> 
                                    <v-row> 
                                        <span class="pb-1"> {{ $t('detail_request.receiver_infor') }} </span>
                                    </v-row>
                                    <v-row class="pb-1"> {{ $t('detail_request.receiver') }} {{ customer.defaultAddress ? customer.defaultAddress.name : customer.fullname }}</v-row>
                                    <v-row class="pb-1"> {{ $t('detail_request.receive_phone') }} {{ customer.defaultAddress ? customer.defaultAddress.phone : customer.phone }} </v-row>
                                    <v-row class="pb-1"> {{ $t('detail_request.receive_address') }} {{ addressToString(customer.defaultAddress) }} </v-row>
                                </v-col>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-space-between">
                    <v-btn class="ml-5" width="120px" dark color="primary" @click="closeDialog()"> {{ $t('common.close') }}</v-btn>
                    <v-btn class="mr-5" width="120px" dark color="primary" @click="sendRequest()">
                        {{ $t('common.send') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <customer-dialog :showDialog="dialogAddCustomer" :editedItem="customer" :editedIndex="editedCustomerIndex" @closeDialog="closeCustomerDialog" @updateCustomer="updateCustomer" v-if="customer"> 
        </customer-dialog>
    </div>
</template>

<script>
    import moment from 'moment';
    import i18n from '@/plugins/i18n';
    import VNumericField from "@/components/VNumericField";
    import CustomerDialog from "@/components/CustomerDialog";

    export default {
        name: 'edit-ship-request-dialog',

        props: {
            value: Boolean,
            editedItem: Object
        },

        components: {
            VNumericField: VNumericField,
            CustomerDialog: CustomerDialog
        },


        data: ()=> ({
            baseImage: process.env.VUE_APP_BASE_IMAGE,
            baseAttach: process.env.VUE_APP_BASE_ATTACH,

            modalDate: false,
            modalTime: false,

            receiveDate: moment(String(new Date())).format("YYYY-MM-DD"),
            receiveTime: '12:00',

            selectMethod: {value: 1, name: 'Thu tiền qua hệ thống ship'},
            paymentMethods: [
                {value: 1, name: 'Thu tiền qua hệ thống ship'},
                {value: 2, name: 'Sale tự thu tiền'}
            ],

            gifts: [],
            selectGift: [],
            customer: {},

            dialogAddCustomer: false,
            editedCustomerIndex: 0, 
        }),

        computed: {
            computedReceiveDateFormatted () {
                return this.formatDate(this.receiveDate);
            }
        },

        watch: {
            
        },

        mounted() {
           
        },

        created () {
            this.customer = this.editedItem.customer;
            this.editedItem.numberOfProductReceived = this.calculateTotalSizeOfAll(this.editedItem);
            this.calculateMoneyHasToPay();
            this.getAllGiftByNumber(this.calculateTotalSizeOfAll(this.editedItem));

            if (Array.isArray(this.editedItem.gifts) && this.editedItem.gifts.length > 0) {
                this.selectGift = this.editedItem.gifts;
            }

            this.receiveTime = this.editedItem.receiveTime ? this.editedItem.receiveTime : '00:00';

            if (this.editedItem.paymentMethod === 1) {
                this.selectMethod = this.paymentMethods[0];
            } else if (this.editedItem.paymentMethod === 2) {
                this.selectMethod = this.paymentMethods[1];
            }
        },

        methods: {
            formatDate (date) {
                if (!date) {
                    return null;
                }

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },

            closeDialog() {
                this.$emit('closeDialog', false);
            },

            async sendRequest() {
                let requestBody = Object.assign({}, this.editedItem);

                requestBody = {
                    ...requestBody,
                    customer: this.customer._id,
                    receiveDate: moment(String(this.receiveDate)).format("DD/MM/YYYY"),
                    deadline: moment(String(this.editedItem.deadline)).format("DD/MM/YYYY")
                }
                
                const response =  await this.$http.put('/manufactureRequest/' + this.editedItem._id, requestBody);
                if (response.data && response.data.success) {
                    this.$fire({
                        title: i18n.t('common.update_success'),
                        text: "",
                        type: "success"
                        }).then(() => {
                            this.$emit('update', this.editedItem);
                            this.closeDialog();
                        });
                } else if (response.data && !response.data.success) {
                    alert(response.data.message);
                } else {
                    alert(i18n.t('validate.request_error'));
                }
            },

            calculateMoneyHasToPay() {
                const prepay = this.editedItem.prepay ? this.editedItem.prepay : 0;
                let moneyHasToPay = this.editedItem.total - prepay;

                this.editedItem.totalEdit = this.editedItem.totalEdit ? this.editedItem.totalEdit : moneyHasToPay;
            },

            async getAllGiftByNumber(numberProfile) {
                try {
                    const response = await this.$http.get('/gift/query/0?number=' + numberProfile);
                    if (response.data && response.data.success) {
                        const contextArr = response.data.data;
                        this.gifts = contextArr;
                    }
                } catch (e) {
                    console.log(e.stack);
                }
            },

            calculateTotalSizeOfAll(detail) {
                let total = 0;
                if (detail.request_details) {
                    detail.request_details.forEach(detail => {
                        total = total + this.calculateTotalSizeOfProduct(detail);
                    });
                }

                return total;
            },

            calculateTotalSizeOfProduct(detail) {
                let total = 0;
                detail.profilesInfo.forEach(item => {
                    total = total + this.calculateProfile(item.sizes);
                });

                return total;
            },

            calculateProfile(sizes) {
                let total = 0;
                sizes.forEach(size => {
                    if (!size.number) {
                        size.number = 0;
                    } else {
                        total = total + parseInt(size.number, 10);
                    }
                });

                return total;
            },

            closeCustomerDialog(value) {
                this.dialogAddCustomer = value
            },

            updateCustomer(value) {
                this.customer = value;
            },

            editCustomer() {
                this.dialogAddCustomer = true;
            },

            addressToString(detail) {
                if (detail && detail.fullDetail) {
                    return detail.fullDetail;
                } else {
                    return '';
                }
            },
        }
    }
</script>


